import { lang } from '@src/lang'

interface Props {
    completed: number
    total: number
}

export const ProgressBar = (props: Props) => {
    return (
        <div className="progress-container">
            <div className="progress-text">
                {lang.progressBarPlaceholder(props.completed, props.total)}
            </div>
            <div className="progress-bar">
                <div
                    className="progress-fill"
                    style={{
                        width: `${(props.completed / props.total) * 100}%`,
                    }}
                />
            </div>
        </div>
    )
}
